import { render, staticRenderFns } from "./standart-category-name.vue?vue&type=template&id=8e22a99e&"
import script from "./standart-category-name.vue?vue&type=script&lang=ts&"
export * from "./standart-category-name.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports